/**
 * @file 编辑器相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';

/**
 * 上传资源
 * @returns Promise
 */
export const uploadResource = async (api, params) => {
    return request(
        api, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 删除资源
 * @returns Promise
 */
export const delResource = async (api, params) => {
    return request(
        api, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 背景图上传：轮询后端处理结果
 * @returns Promise
 */
export const pollBgUpdloadResult = async (api, params) => {
    return request(
        api,
        {
            method: 'POSTJSON',
            body: params
        }
    );
};


/**
 * 获取资源库列表
 * @returns Promise
 */
export const getReourceLibList = async (api, params) => {
    return request(
        api, {
            method: 'POSTJSON',
            body: params
        }
    );
};


/**
 * 获取AI生成列表
 * @returns Promise
 */
export const getAITemplateList = async (api, params) => {
    return request(
        api, {
            method: 'POSTJSON',
            body: params
        }
    );
};


/**
 * 获取bos上传校验参数
 * @returns Promise
 */
export const getSTSConfig = async () => {
    return request(
        API.GET_STS_CONFIG, {
            method: 'POST'
        }
    );
};

/**
 * 获取我的店铺-商品列表
 * @returns Promise
 */
export const dhDuShopGoodsList = async params => {
    return request(
        // eslint-disable-next-line
        'https://cecom.baidu.com/proxy/select/v3/dushop_goods_list?access_name=cecom_fe&ak=cecom_fe&sign=7c456e568fdf1c5d1e40e8efc9461291',
        {
            method: 'POST',
            body: {
                ...params
            }
        },
        'pc_interface'
    );
};

/**
 * 根据spuId获取商品的全部图片
 * @returns Promise
 */
export const getSpuImgList = async params => {
    return request(
        API.GET_SPU_IMG_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 模板列表
 * @returns Promise
*/
export const getTemplateList = async params => {
    return request(
        API.TEMPLATE_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 商品信息
 * @returns Promise
*/
export const getGoodsInfo = async params => {
    return request(
        API.GET_GOODS_INFO, {
            method: 'POSTJSON',
            body: params
        }
    );
};


/**
 * 公共模板列表
 * @returns Promise
*/
export const getPublicTemplateList = async params => {
    return request(
        API.PUB_TEMPLATE_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 根据ID获取模板
 * @returns Promise
 */
export const getTemplateById = async (api, params) => {
    return request(
        api, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 模板创建
 * @returns Promise
*/
export const createTemplate = async params => {
    return request(
        API.TEMPLATE_CREATE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 模板保存
 * @returns Promise
*/
export const saveTemplate = async params => {
    return request(
        API.TEMPLATE_SAVE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 模板删除
 * @returns Promise
*/
export const delTemplate = async params => {
    return request(
        API.TEMPLATE_DEL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 裁剪视频
 * @returns Promise
 */
export const cutBgVideo = async params => {
    return request(
        API.CUT_BACKGROUND_VIDEO, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 图片转存
 * @returns Promise
 */
export const transImage = async url => {
    return request(
        API.TRANS_IMAGE, {
            method: 'POSTJSON',
            body: {
                img_url: url
            }
        }
    );
};
/**
 * 获取裁剪进度
 * @returns Promise
 */
export const cutBgVideoTask = async params => {
    return request(
        API.CUT_BACKGROUND_VIDEO_PROGRESS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 批量查询进度
 * @returns Promise
 */
export const cutBgVideoTaskBatch = async params => {
    return request(
        API.CUT_BACKGROUND_VIDEO_BATCH, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 个人素材库模板
 * @returns Promise
*/
export const getStickersCustomList = async params => {
    return request(
        API.GET_PASTER_LIB_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 素材库上传
 * @returns Promise
*/
export const uploadPasterImage = async params => {
    return request(
        API.UPLOAD_PASTER_IMG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 公共素材库列表
 * @returns Promise
*/
export const getPublicPaster = async params => {
    return request(
        API.GET_PUBLIC_PASTER, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 公共素材库类别
 * @returns Promise
*/
export const getCategoryList = async params => {
    return request(
        API.GET_PASTER_CATEGORY, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 删除素材
 * @returns Promise
*/
export const delPasterImg = async params => {
    return request(
        API.DEL_PASTER_IMG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心剧本优化
 * @returns Promise
 */
export const getErnieText = async params => {
    return request(
        API.GET_ERNIE_TEXT, {
            method: 'POSTJSON',
            body: params
        }
    );
};
export const getErnieTextV2 = async params => {
    return request(
        API.GET_ERNIE_TEXT_V2, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 背景视频列表
 * @returns Promise
*/
export const getBgVideoList = params => {
    return request(
        API.GET_BG_VIDEO_LIB_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 背景视频上传
 * @returns Promise
*/
export const uploadBgVideo = params => {
    return request(
        API.UPLOAD_BG_VIDEO_IMG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 背景视频删除
 * @returns Promise
*/
export const delBgVideo = params => {
    return request(
        API.DEL_BG_VIDEO, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 获取贴片组
 * @returns Promise
*/
export const getPasterGroup = params => {
    return request(
        API.GET_PASTER_GROUP_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

export const getCharacterList = async params => {
    return request(
        API.GET_CHARACTER_LIB_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

export const getFontList = params => {
    return request(
        API.GET_FONT_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

export const getFontStyleList = params => {
    return request(
        API.GET_FONT_STYLE_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * ppt 解析
 * @returns Promise
*/
export const pptAnalysis = params => {
    return request(
        API.PPT_ANALYSIS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * ppt 解析结果
 * @returns Promise
*/
export const pptAnalysisResult = params => {
    return request(
        API.PPT_ANALYSIS_RESULT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * ppt 智能匹配
 * @returns Promise
*/
export const pptAIMatch = params => {
    return request(
        API.PPT_AI_MATCH, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * ppt 智能匹配结果轮训
 * @returns Promise
*/
export const pptAIMatchResult = params => {
    return request(
        API.PPT_AI_MATCH_RESULT, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 获取公共素材库分类
 * @returns Promise
*/
export const getPublicPasterCategory = params => {
    return request(
        API.GET_PUBLIC_PASTER_CATEGORY, {
            method: 'POSTJSON',
            body: params
        }
    );
};